import { parseQs, useHashQs, useQs } from '@bowtie-web/common';
import { useMemo } from 'react';
import { ANCHOR_LINK_VARIANT_MAPPINGS } from '../QuotationWidget/MarketingPageAnchorLink/MarketingPageAnchorLink';

export type QuotationQs = {
  type: string;
  gender: 'male' | 'female';
  age: string;
  smoker: 'smoker' | 'non-smoker';
  defaultCoupon: string;
  defaultCouponType: string;
  variableAttribute: string;
  defaultVariable: string;
  defaultOption: string;
  lang: 'en' | 'zh-hk';
  promoted: string;
  button: '1' | '2';
  productsShow: string;
  riderOptions: 'default' | string; // 'default' will show all available rider options
  defaultRiderOption: 'none' | string;
  showRecommendationAnchor: 'true'; // TODO(LING): will deprecate this and migrate to the use of anchorLinkType
  anchorLinkType: keyof typeof ANCHOR_LINK_VARIANT_MAPPINGS;
  showSocialProofMessage: 'true';
  shouldShowBanner: 'true';
  shouldShowMedicalRiderHeadline: 'true';
  shouldShowVariableAttributeButtons: 'true';
  publicDefaultCouponTypes: string;
  existingCustomerDefaultCouponTypes: string;
  isExistingCustomer: 'true';
  defaultFormValues: string; // different from gender, smoker and age, this set the initial form values only and won't affect the app start URL
  termLifeYear: string | undefined; // expect to be '1' | '5' | '10' | '20'  if provided
};

/**
 * Overriding order:
 * parent querystring > iframe querystring > iframe hash > local storage > form default params
 */
const useQuotationQs = () => {
  const hashQs = useHashQs<QuotationQs>();

  // use params from the page itself anyway, no matter it is iframe or not
  const searchQs = useQs<QuotationQs>();

  const iframeParentQs = useMemo(() => {
    // if the page is in an iframe, try to use params from the parent if possible
    let isIframeAndCanAccessParent = false;
    try {
      isIframeAndCanAccessParent =
        !!window.parent &&
        window.location !== window.parent.location &&
        !!window.parent.location.search;
    } catch {
      // failed to access attributes of parent, probably due to CORS
    }
    return isIframeAndCanAccessParent
      ? parseQs(window.parent.location.search)
      : {};
  }, []);

  return {
    ...hashQs,
    ...searchQs,
    ...iframeParentQs,
  };
};

export default useQuotationQs;
